import React from 'react'
import { useLocation } from 'react-router-dom'
import { ZENDESK_WIDGET_ALLOWED_PATHS } from '../../constants'

const ZENDESK_WIDGET_SCRIPT_URL =
  'https://static.zdassets.com/ekr/snippet.js?key=9f050243-b1ca-45fb-9887-a8c6945ae75c'
const ZENDESK_WIDGET_SCRIPT_ID = 'ze-snippet'

export const useZendeskWidget = () => {
  const { pathname } = useLocation()

  React.useEffect(() => {
    const isAllowed = ZENDESK_WIDGET_ALLOWED_PATHS.includes(pathname)
    const isZendeskWidgetExists = typeof window?.zE === 'function'

    if (isAllowed && !isZendeskWidgetExists) {
      const script = document.createElement('script')
      script.src = ZENDESK_WIDGET_SCRIPT_URL
      script.id = ZENDESK_WIDGET_SCRIPT_ID
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    } else if (isAllowed && isZendeskWidgetExists) {
      if (window.zE('webWidget:get', 'display') === 'hidden') {
        window.zE('webWidget', 'show')
      }
    } else if (!isAllowed && isZendeskWidgetExists) {
      if (window.zE('webWidget:get', 'display') !== 'hidden') {
        window.zE('webWidget', 'hide')
      }
    }
  }, [pathname])
}
